import React from 'react';
import { Helmet } from 'react-helmet';

const PreloadStatic = () => (
  <Helmet>
    <link rel="preconnect" href="https://widgets.opinary.com" />
    <link rel="prefetch" as="image" href="https://d33sjysxhm81uh.cloudfront.net/wework/Homepage_Desktop.jpg" />
    <link rel="prefetch" as="image" href="https://d33sjysxhm81uh.cloudfront.net/wework/Article_1_hero.jpg" />
    <link rel="prefetch" as="image" href="https://d33sjysxhm81uh.cloudfront.net/wework/Article_2_hero.jpg" />
    <link rel="prefetch" as="image" href="https://d33sjysxhm81uh.cloudfront.net/wework/Article_3_hero.jpg" />
    <link rel="prefetch" as="image" href="https://d33sjysxhm81uh.cloudfront.net/wework/Article_4_hero.jpg" />
  </Helmet>
);

export default PreloadStatic;
